



































import Vue from "vue";
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import "./dropdown.less";

@Component
export default class SimpleDropdown extends Vue {
  @Prop() value: any;
  @Prop(Array) dataSource!: Array<any>;
  @Prop(String) displayProp!: string;
  @Prop(String) placeholder!: string;
  @Prop(Boolean) nullable = false;
  @Prop(Boolean) changeUrl = false;
  @Prop(Boolean) errorClass = false;

  inputChange(item){
    this.input(item);
  }


  @Emit()
  input(item) {
  }
}
